import axios from '@_system/axios/axios.js'
export default {
	path: '/BIshopgoodskpi',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	batchsave(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/batchsave', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	batchdelete(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/batchdelete', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/Bi.Shopgoods', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	}
}